import { useCallback } from "react";
import { IOpenPanel } from "../../../../Interfaces/IPanel";
import { UsePanelEquipoSync } from "./UsePanelEquipoSync";
import { PanelFooter } from "../../../../components/Panel/PanelFooter";
import { PanelDrawer } from "../../../../components/Panel/PanelDrawer";
import { Body1, Card, Title1 } from "@fluentui/react-components";
import { Spinner } from "@fluentui/react";
import { IEquipoSync } from "../../../../Interfaces/estadoEquipos/IEstadoEquipo";

export const PanelEquipoSync=(props:IOpenPanel)=>{
    const usePanel = UsePanelEquipoSync(props)
    const onRenderFooter = useCallback(
        () => (
          <>
            {usePanel.equiposSync.length!=0 && (
            <PanelFooter
              texto="Guardar"
              texto2={"Salir"}
              //disableButton={disableForm}
              onClick={usePanel.SyncronizarEquipo}
              onDismiss={usePanel.reset}
            />)}
          </>
        ),
        [usePanel.equiposSync]
      );
      return(
        <PanelDrawer isOpen={props.isOpen} onDismiss={usePanel.reset} 
        onRenderFooter={onRenderFooter}
        textHeader={"Equipos Encontrados a Sincronizar"} status={usePanel.status} mensaje={usePanel.mensaje} 
        loading={usePanel.loading}>
            <br/>
            {!usePanel.LoadingSincronizar ? (<>
            {usePanel.equiposSync.length==0?(<Body1>
                Por el Momento, todos las equipos ya han sido insertados
            </Body1>):(
                <>
                {usePanel.equiposSync.map((item:IEquipoSync,index:number)=>(
                   <Card>
                   <Title1>{item.equipoCodigo}</Title1>
                   <Body1>Modelo: {item.equipoModelo}</Body1>
                   </Card>
                )
                )}
                </>
            )}
            </>):(<Spinner></Spinner>)}
        </PanelDrawer>
      )
}